/**
 * ===========================================
 * StudySpace ERP Frontend - Auth Validation
 * ===========================================
 * 
 * Yup validation schemas for authentication forms.
 * 
 * @file src/validations/auth.validation.js
 * @description Validation schemas for login and register forms
 */

import * as Yup from 'yup';
import { VALIDATION } from '../utils/constants';

/**
 * Login form validation schema
 */
export const loginSchema = Yup.object().shape({
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(VALIDATION.PASSWORD_MIN, `Password must be at least ${VALIDATION.PASSWORD_MIN} characters`)
    .required('Password is required')
});

/**
 * Register form validation schema
 */
export const registerSchema = Yup.object().shape({
  name: Yup.string()
    .min(VALIDATION.NAME_MIN, `Name must be at least ${VALIDATION.NAME_MIN} characters`)
    .max(VALIDATION.NAME_MAX, `Name cannot exceed ${VALIDATION.NAME_MAX} characters`)
    .required('Name is required'),
  email: Yup.string()
    .email('Please enter a valid email address')
    .required('Email is required'),
  password: Yup.string()
    .min(VALIDATION.PASSWORD_MIN, `Password must be at least ${VALIDATION.PASSWORD_MIN} characters`)
    .max(VALIDATION.PASSWORD_MAX, `Password cannot exceed ${VALIDATION.PASSWORD_MAX} characters`)
    .required('Password is required'),
  cPassword: Yup.string()
    .oneOf([Yup.ref('password'), null], 'Passwords must match')
    .required('Confirm password is required'),
  phone: Yup.string()
    .nullable()
    .min(VALIDATION.PHONE_MIN, `Phone must be at least ${VALIDATION.PHONE_MIN} digits`)
    .max(VALIDATION.PHONE_MAX, `Phone cannot exceed ${VALIDATION.PHONE_MAX} digits`)
});
